import { render, staticRenderFns } from "./flightNoData.vue?vue&type=template&id=520249c7"
import script from "./flightNoData.vue?vue&type=script&lang=js"
export * from "./flightNoData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports